// extracted by mini-css-extract-plugin
module.exports = {"regular":"Weight_regular__3XTQ2","medium":"Weight_medium__Ok4uO"};